import { globalConfig } from './config.global';
import { Config, ConfigEnv } from './config.interface';

export const config: Config = {
  ...globalConfig,
  env: ConfigEnv.LOCAL,
  apiBasePath: 'https://clientgateway.dvlp.delen.be/api/datasharing',
  // apiBasePath: '/api/', // use me with `npm run start-local-dev`
  // apiBasePath: 'https://localhost:5000/api',
  authBaseUrl: 'https://auth-server.dvlp.delen.be/thirdparty-communication-management',
  showMissingTranslations: true,
  azureAppInsightsInstrumentationKey: '7c798a9e-c914-4f68-8baa-6519fa5d1cdd',
};
